import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

/**
 * Slow editorial ribbon — serif italic terms separated by an asterisk motif.
 */
export const EditorialMarquee = ({ items = [], speed = 30 }) => {
  return (
    <div className="border-y border-[var(--line)] bg-[var(--bg-2)] py-10">
      <Marquee gradient={false} speed={speed} pauseOnHover={false}>
        {items.map((label, i) => (
          <div
            key={`${label}-${i}`}
            className="flex items-center gap-10 pr-10"
          >
            <span className="font-serif-accent text-[clamp(2.5rem,6vw,5rem)] text-[var(--ink)] whitespace-nowrap">
              {label}
            </span>
            <Asterisk
              className="w-6 h-6 text-[var(--accent)] shrink-0"
              strokeWidth={1.2}
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
